import { useMemo, useState } from 'react'

import type { Stage } from '../AddSubscriptionModal.types'

const stages = ['INTRO', 'SELECT_PLAN', 'PAYMENT', 'SUCCESS'] as Stage[]

export const useStage = (initialStage?: Stage) => {
  const [stage, setStage] = useState(initialStage || stages[0])

  const canGoToPreviousStage = useMemo(
    () => stages.indexOf(stage) !== 0 && stage !== 'SUCCESS',
    [stage],
  )

  const goToPreviousStage = () => {
    const currentStageIndex = stages.indexOf(stage)

    if (currentStageIndex !== 0) {
      setStage(stages[currentStageIndex - 1])
    }
  }

  const goToNextStage = () => {
    const currentStageIndex = stages.indexOf(stage)

    if (currentStageIndex !== stages.length - 1) {
      setStage(stages[currentStageIndex + 1])
    }
  }

  return { stage, canGoToPreviousStage, goToPreviousStage, goToNextStage }
}
